import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Feedback {
  static api = api.create(Feedback)

  constructor({ email = '', name = '', phone = '', subject = '', message = '' } = {}) {
    Object.assign(this, {
      email,
      name,
      phone,
      subject,
      message,
    })
  }

  copy() {
    return new Feedback(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Feedback(data)
  }

  static fromAPI(json = {}) {
    return new Feedback(objectToCamelCase(json))
  }

  /**
   *  Prep data for the API.
   **/
  static toAPI(feedback, fields = []) {
    // By default, send the whole project
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = feedback[field]
      })
    } else {
      data = feedback
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Feedback)) {
      throw Error(`${name} must be an instance of the Feedback class.`)
    }
  }
}
